export default __webpack_public_path__ + "static/media/learose5-480w.c0e66273.png";